export { default as AnnotationField } from "../stores/AnnotationField.js";
var DrawMode;

(function (DrawMode) {
  DrawMode["TextField"] = "textField";
  DrawMode["Autofill"] = "autofill";
  DrawMode["Signature"] = "signature";
  DrawMode["Initials"] = "initials";
  DrawMode["Checkbox"] = "checkbox";
  DrawMode["DateSigned"] = "dateSigned";
})(DrawMode || (DrawMode = {}));

export { DrawMode };